import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "datatables.net";
import "datatables.net-bs4";
import $ from "jquery";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  PremisesListData,
  PremisesListResponse,
} from "../../helpers/response/Admin/PremiseListResponse";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Select from "react-select";
import useWindowDimensions from "../../Utils/useWindowDimensions";

import AirHomeLoader from "./AirHomeLoader";

export interface interfaceDataTable<T> {
  responseType?: T;
  apiURL: string;
  columns: any[];
  btnName?: string;
  isAddBtnShow?: boolean;
  btnStyle?: any;
  isBtnShow?: boolean;
  secondBtnText?: string;
  secondBtnStyle?: any;
  onClickBtn?: () => void;
  secondBtnOnClick?: () => void;
  handleEditClick?: (data: any) => void | undefined;
  handleDeleteClick?: (data: any) => void;
  onDataTableRefresh?: (dataTableId: any) => void;
  idName: string;
  handleColumnClicked?: (data: any) => void | undefined;
  paramsId?: any;
  isEntryShow?: boolean;
  isClicked?: boolean;
  showFilterOpetions?: boolean;
  optionGroup?: any[];
  showSearchebleFilter?: boolean;
  searchableFilterOption?: any;
  setFilterValue?: any;
  searchAPICall?: any;
  filterValue?: string;
  searchableCityOption?: any;
  cityFilterValue?: string;
  setCityFilterValue?: any;
  searchCityAPICall?: any;
  isShowSearch?: boolean;
  handleDropdownClick?: any;
  isReload?: boolean;
  setReload?: any;
}
const DataTable = <T,>({
  responseType,
  apiURL,
  columns,
  btnName,
  isAddBtnShow,
  btnStyle,
  isBtnShow,
  secondBtnText,
  secondBtnStyle,
  onClickBtn,
  secondBtnOnClick,
  handleEditClick,
  handleDeleteClick,
  onDataTableRefresh,
  idName,
  handleColumnClicked,
  paramsId,
  isEntryShow,
  isClicked,
  showFilterOpetions,
  optionGroup,
  showSearchebleFilter,
  searchableFilterOption,
  searchableCityOption,
  setFilterValue,
  searchCityAPICall,
  searchAPICall,
  cityFilterValue,
  filterValue,
  setCityFilterValue,
  isShowSearch,
  handleDropdownClick,
  setReload,
}: interfaceDataTable<T>) => {
  const { width } = useWindowDimensions();
  const [tableData, setTableData] = useState<PremisesListData[]>([]);

  const [selectFilter, setSelectFilter] = useState<any>({
    label: "First Name / Last Name",
    value: 0,
  });
  const [searchValue, setSeachValue] = useState("");

  const tableRef: any = useRef(null);

  const token = localStorage.getItem("Authorization");
  var initializeTable = 0;

  let dataTableInstance: any = null;
  const fetchData = (dataTablesData: any, callback: any) => {
    if (idName === "DebugDeviceDetails") {
      setReload(false);
    }

    $("#customLoader").show();

    var reqObj: any;
    showFilterOpetions
      ? (reqObj = {
          ...dataTablesData,
          ...paramsId,
          filterType: selectFilter.value,
          search: {
            value: searchValue,
            regex: false,
          },
        })
      : showSearchebleFilter
      ? (reqObj = {
          ...dataTablesData,
          ...paramsId,
          filterType: selectFilter.value,
          search: {
            value: searchValue, // Include the search value
            regex: false, // You can adjust this based on your requirements
          },
        })
      : (reqObj = {
          ...dataTablesData,
          ...paramsId,
          filterType: selectFilter.value,
          search: {
            value: searchValue, // Include the search value
            regex: false, // You can adjust this based on your requirements
          },
        });
    axios
      .post(apiURL && apiURL, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const res: PremisesListResponse = response.data;
        $("#customLoader").hide();
        callback({
          draw: dataTablesData.draw,
          recordsTotal: res.recordsTotal,
          recordsFiltered: res.recordsFiltered, // You might adjust this based on filtered records
          data: res.data,
        });
        if (idName === "DebugDeviceDetails") {
          if (dataTablesData?.start >= 10) {
            setReload(false);
          } else {
            setReload(true);
          }
        }
        setTableData(res.data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          // localStorage.clear();
          localStorage.removeItem("userInfo");
          localStorage.removeItem("selectedPremiseID");
          localStorage.removeItem("selectedUserID");
          localStorage.removeItem("selectedUserEmail");
          localStorage.removeItem("Authorization");
          localStorage.removeItem("permissions");
          window.location.reload();
        } else {
          // Handle other errors as needed
          console.error("Error fetching data:", err);
        }
      });
  };

  const initializeData = () => {
    try {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }

      dataTableInstance = $(tableRef.current).DataTable({
        processing: false,
        serverSide: true,
        ajax: fetchData,
        columns: columns,
        searching: true,
        ordering: false,
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
    }

    $(tableRef.current).on("change", ".dropdown-btn", function () {
      const selectedValue = $(this).val();
      const rowIndex = dataTableInstance.row($(this).closest("tr")).index();
      const rowData = dataTableInstance.row(rowIndex).data();

      // Now you have feedbackId and selectedValue, make your API call here
      // Example Axios call:
      handleDropdownClick && handleDropdownClick(rowData, selectedValue);
    });

    $(tableRef.current).on("click", ".column-click", function () {
      const data = dataTableInstance.row($(this).closest("tr")).data();
      if (!isClicked) {
        return; // Abort further actions
      }
      handleColumnClicked && handleColumnClicked(data);
    });
    {
      !isEntryShow &&
        $(tableRef.current)
          .closest(".dataTables_wrapper")
          .find(".dataTables_length")
          .hide();

      $(tableRef.current)
        .closest(".dataTables_wrapper")
        .find(".dataTables_filter")
        .hide();
    }
    $(tableRef.current).on("click", ".edit-btn", function () {
      const rowData = dataTableInstance.row($(this).parents("tr")).data();
      handleEditClick && handleEditClick(rowData);
    });

    $(tableRef.current).on("click", ".delete-btn", function () {
      const rowData = dataTableInstance.row($(this).parents("tr")).data();
      handleDeleteClick && handleDeleteClick(rowData);
    });
    $(tableRef.current).on("preXhr.dt", function () {
      $("#customLoader").show();
    });

    $(tableRef.current).on("xhr.dt", function () {
      $("#customLoader").hide();
    });
    $(tableRef.current).find("thead th").css("background-color", "#EFF2F7");
  };

  useEffect(() => {
    initializeData();
  }, [selectFilter, searchValue, filterValue, cityFilterValue]);

  useEffect(() => {
    if (paramsId?.filter && paramsId?.filter !== null) {
      initializeData();
    }
  }, [paramsId]);

  useEffect(() => {
    const dataTableId = $(tableRef.current).attr("id");
    onDataTableRefresh && onDataTableRefresh(dataTableId);
  }, []);

  const handleCustomSearch = (value: any) => {
    setSeachValue(value);
  };

  function handleSelectFilter(selectedValue: any) {
    setSelectFilter(selectedValue);
  }

  interface CustomStyles {
    menu?: (provider: any) => any;
    control?: (base: any, state: any) => any;
    // ... other style properties as needed
  }

  const customStyles = {
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white", // Set background color for the dropdown menu
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Optional: Add shadow
      fontWeight: "normal", // Set font weight for the dropdown menu
    }),
    placeholder: (provided: any, state: any) => ({
      ...provided,
      color: "#6c757d", // Placeholder color
      fontWeight: "normal", // Placeholder font-weight
    }),
    singleValue: (provided: any, state: any) => ({
      ...provided,
      color: "#333", // Change selected value color
      fontWeight: "normal", // Change selected
      // Add any other custom styles for the selected value here if needed
    }),
  };

  return (
    <Card
      style={{
        marginTop: 100,
        marginLeft: 30,
        marginRight: 30,
        marginBottom: 0,
      }}
    >
      <CardBody>
        <div className="mb-4 h4 card-title d-flex flex-column flex-md-row justify-content-between">
          {showFilterOpetions ? (
            <div
              className="justify-content-between flex-row d-flex"
              style={{ gap: 10 }}
            >
              <div className="" style={{ width: 500 }}>
                <Select
                  value={selectFilter}
                  onChange={handleSelectFilter}
                  options={optionGroup}
                  className="select2-selection"
                  styles={customStyles}
                  placeholder="Select..."
                />
              </div>
              <div
                className="app-search d-flex flex-column flex-md-row align-items-center mb-3 mb-md-0"
                style={{ width: "100%" }}
              >
                <div className="position-relative" style={{ width: "100%" }}>
                  <span>
                    <box-icon
                      name="search-alt"
                      color="#74788d"
                      size="16px"
                    ></box-icon>
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    style={{
                      border: "1px solid #ccc",
                      background: "#F7F9FC",
                      color: "#858D9D",
                    }}
                    placeholder={"Search..."}
                    onChange={(e) => handleCustomSearch(e.target.value)}
                    value={searchValue}
                  />
                </div>
              </div>
            </div>
          ) : showSearchebleFilter ? (
            <div className="d-flex flex-column flex-md-row" style={{ gap: 10 }}>
              <div
                className="d-block mb-3 mb-md-0"
                style={{
                  width: isShowSearch
                    ? width < 800
                      ? 350
                      : width < 1050
                      ? 200
                      : 350
                    : 550,
                }}
              >
                <Select
                  name="stete"
                  onFocus={() => searchAPICall("a")}
                  value={searchableFilterOption?.find(
                    (option: any) => option?.value === filterValue
                  )}
                  options={searchableFilterOption}
                  onChange={(selectedOption: any) => {
                    setFilterValue(selectedOption);
                    setCityFilterValue &&
                      setCityFilterValue({ label: "All", value: "all" });
                  }}
                  onInputChange={(e) => {
                    searchAPICall(e);
                    setCityFilterValue &&
                      setCityFilterValue({ label: "All", value: "all" });
                  }}
                  styles={customStyles}
                />
              </div>
              {setCityFilterValue && (
                <div
                  className="d-block mb-3 mb-md-0"
                  style={{
                    width: width < 800 ? 350 : width < 1050 ? 200 : 350,
                  }}
                >
                  <Select
                    name="city"
                    onFocus={() => searchCityAPICall("a")}
                    value={searchableCityOption.find(
                      (option: any) => option.value === cityFilterValue
                    )}
                    options={searchableCityOption}
                    onChange={setCityFilterValue} // Ensure selectedOption.value contains the desired value
                    onInputChange={(e) => {
                      searchCityAPICall(e);
                    }} // Make sure this function works as expected
                    styles={customStyles}
                  />
                </div>
              )}
              {isShowSearch && (
                <div
                  className="app-search d-flex flex-column flex-md-row align-items-center mb-3 mb-md-0"
                  style={{ width: "60%" }}
                >
                  <div className="position-relative" style={{ width: "95%" }}>
                    {/* <span className="bx bx-search-alt" /> */}
                    <span>
                      <box-icon
                        name="search-alt"
                        color="#74788d"
                        size="16px"
                      ></box-icon>
                    </span>
                    <input
                      type="search"
                      className="form-control"
                      style={{
                        border: "1px solid #ccc",
                        background: "#F7F9FC",
                        color: "#858D9D",
                      }}
                      placeholder={"Search..."}
                      onChange={(e) => handleCustomSearch(e.target.value)}
                      value={searchValue}
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              className="app-search d-flex flex-column flex-md-row align-items-center mb-3 mb-md-0"
              style={{}}
            >
              {!isShowSearch && (
                <div className="position-relative" style={{ width: "100%" }}>
                  {/* <span className="bx bx-search-alt" /> */}
                  <span>
                    <box-icon
                      name="search-alt"
                      color="#74788d"
                      size="16px"
                    ></box-icon>
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    style={{
                      border: "1px solid #ccc",
                      background: "#F7F9FC",
                      color: "#858D9D",
                    }}
                    placeholder={
                      idName === "BackupList"
                        ? "Search by Email and Mobile No."
                        : "Search..."
                    }
                    onChange={(e) => handleCustomSearch(e.target.value)}
                    value={searchValue}
                  />
                </div>
              )}
            </div>
          )}

          <div
            className="justify-content-between flex-row d-flex"
            style={{ gap: 20 }}
          >
            {isAddBtnShow && (
              <button
                className={btnStyle}
                onClick={() => onClickBtn && onClickBtn()}
              >
                {btnName}
              </button>
            )}
            {isBtnShow && (
              <button
                className={secondBtnStyle}
                style={{ gap: 20 }}
                onClick={() => secondBtnOnClick && secondBtnOnClick()}
              >
                {secondBtnText}
              </button>
            )}
          </div>
        </div>
        <div>
          {/* <Spinners /> */}
          <div id="customLoader">
            <AirHomeLoader />
          </div>
          {initializeTable === 0 &&
            ((initializeTable = 1),
            (
              <div className="table-responsive">
                <table
                  id={`dataTable${idName}`}
                  ref={tableRef}
                  className="table table-hover"
                  style={{ width: "100%", fontSize: 14, color: "#858D9D" }}
                ></table>
              </div>
            ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default DataTable;
